export enum NotificationType {
  TaskAssigned = "task_assigned",
  TaskCompleted = "task_completed",
  TaskOverdue = "task_overdue",
  TaskComment = "task_comment",
  TaskStatusChanged = "task_status_changed",
  TaskDueSoon = "task_due_soon",
  PositionMissingWorkers = "position_missing_workers",
  MaterialBelowLimit = "material_below_limit",
  MaterialAboveLimit = "material_above_limit",
  ProduceBelowLimit = "produce_below_limit",
  ProduceAboveLimit = "produce_above_limit"
}

export interface INotification {
  _id: string;
  userId: string;
  type: NotificationType;
  title: string;
  message: string;
  taskId?: string;
  taskTitle?: string;
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationFilters {
  isRead?: boolean;
  type?: NotificationType;
  limit?: number;
}

export interface NotificationStats {
  unreadCount: number;
  totalCount: number;
} 